import AssetPath from "../AssetPath/AssetPath";

const TeamData = {
	boardMembers: [
		{
			name: "Tao Gu",
			position: "President",
			linkedinUrl: "",
			profileImage: AssetPath.team.taogu,
		},
		{
			name: "Somy Silvy",
			position: "Vice President",
			linkedinUrl: "",
			profileImage: AssetPath.team.somySilvy,
		},
		{
			name: "Jin Tong",
			position: "Treasurer",
			linkedinUrl: "",
			profileImage: AssetPath.team.jinTong,
		},
		{
			name: "Jane Chen",
			position: "Program Chair NA",
			linkedinUrl: "",
			profileImage: AssetPath.team.janeChen,
		},
		{
			name: "Mayank Misra",
			position: "Board Memeber - Co Chair Marketing and Membership",
			linkedinUrl: "",
			profileImage: AssetPath.team.mayankMisra,
		},

		// {
		//   name: "Sakthi Annamalai",
		//   position: "Program Chair Global",
		//   linkedinUrl: "",
		//   profileImage: AssetPath.team.sakthiAnnamalai,
		// },
		{
			name: "Shan Yeh",
			position: "Marketing & Membership Chair",
			linkedinUrl: "",
			profileImage: AssetPath.team.shanYeh,
		},
		// {
		// 	name: "Suzanne Marzziotti",
		// 	position: "Board Memeber, Program co-Chair",
		// 	linkedinUrl: "",
		// 	profileImage: AssetPath.speakers.suzanneMarzziotti,
		// },
		{
			name: "Wing Chan",
			position: "Publications",
			linkedinUrl: "",
			profileImage: AssetPath.team.wingchan,
		},
	],
	IndustryAdvisoryCommittee: [
		// Industry Advisory Committee
		// {
		//   name: "Karthik Chidambaram",
		//   position: "Past President",
		//   linkedinUrl: "",
		//   profileImage: AssetPath.team.KarthikChidambaram,
		// },

		{
			name: "Ashish Patel",
			position: "Advisory Board Members",
			linkedinUrl: "",
			profileImage: AssetPath.team.ashishPatel,
		},
		{
			name: "Dave Bitner",
			position: "Advisory Board Members",
			linkedinUrl: "",
			profileImage: AssetPath.team.daveBitner,
		},
		{
			name: "Jason Carlin",
			position: "Advisory Board Members",
			linkedinUrl: "",
			profileImage: AssetPath.team.jasonCarlin,
		},
		{
			name: "Paulomi Patel",
			position: "Advisory Board Members",
			linkedinUrl: "",
			profileImage: AssetPath.team.paulomiPatel,
		},
	],
	volunteers: [
		{
			name: "Jess Young",
			position: "2025 Conference",
			linkedinUrl: "",
			profileImage: AssetPath.team.jessYoung,
		},
		{
			name: "Amy Benford",
			position: "2025 Conference",
			linkedinUrl: "",
			profileImage: AssetPath.team.blankImage,
		},
		{
			name: "Ashley Peterson",
			position: "2025 Conference",
			linkedinUrl: "",
			profileImage: AssetPath.team.ashleyPeterson,
		},
		{
			name: "Joe Falcone",
			position: "2025 Conference",
			linkedinUrl: "",
			profileImage: AssetPath.team.joeFalcone,
		},
	],
};

export default TeamData;
